import ContentHeader from "components/common/ContentHeader";

export default function DashboardMng() {
    return(
        <>
            <ContentHeader text="대시보드"/>
        </>
    )
}